import {
  DeleteProductImage,
  EditBaseSKU,
  EditProductProperties,
  EditSKU,
  SaveMeasureImage,
  SaveMeasures
} from '../../../../../infra/requests/ProductsRequests'

const formatPropertiesForSubmit = (properties, product) => {
  const {
    gender,
    business,
    category,
    // subCategory,
    nameAndDescription,
    seo,
    type,
    ...rest
  } = properties

  // used to combine SEO and NameAndDescription
  const combinedTranslations = () => {
    let result = []

    if (nameAndDescription && nameAndDescription.length > 0) {
      nameAndDescription.forEach(translation => {
        const matchingSEO = seo?.find(
          seoItem => seoItem.languageId === translation.languageId
        )
        result.push({
          languageId: translation.languageId,
          name: translation.name,
          description: translation.description,
          metaTitle: matchingSEO?.metaTitle || null,
          metaDescription: matchingSEO?.metaDescription || null
        })
      })
    }

    if (seo && seo.length > 0) {
      seo.forEach(seoItem => {
        const existingEntry = result.find(
          item => item.languageId === seoItem.languageId
        )
        if (!existingEntry) {
          result.push({
            languageId: seoItem.languageId,
            metaTitle: seoItem.metaTitle,
            metaDescription: seoItem.metaDescription
          })
        }
      })
    }
    return result
  }

  return {
    ...rest,
    ProductTypeId: type,
    IsB2c: business,
    MainCategoryId: gender?.toString(),
    CategoryId: category?.toString(),
    SubCategory: '', //subCategory?.toString(), //FIXME when subcategory is fixed
    ReferenceCode: product?.referenceCode,
    ProductTranslation: combinedTranslations(),
    ProductImage: product?.productPropertiesSection?.productImage, // FIXME fix when image tab is developed
    ProductTechnology: properties.technologies.map(elem => ({
      technologyId: elem.technologyId.toString()
    })),
    ProductCharacteristicValue: properties.characteristics.map(elem => ({
      CharacteristicId: elem.characteristicId,
      characteristicValueId:
        elem.characteristicValueId || elem.values[0].characteristicValueId // Temp fix while Characteristic Value is not chosen during characteristic select
    }))
  }
}

const formatKey = key => {
  if (key !== 'measureid') {
    return key.charAt(0).toUpperCase() + key.slice(1)
  } else {
    return 'MeasureId'
  }
}

/*
  This function should be removed once the backend is updated and
  the data is propperly formatted in the DB
*/
const temporaryFormatMeasuresForSubmit = measures => {
  if (!measures) return undefined
  const formattedMeasures = measures.map(measure => {
    const {measuresArray, ...rest} = measure

    if (!rest) return

    const formattedMeasureValues = {}
    if (!measuresArray) return {...rest}

    measuresArray.forEach(measureRecord => {
      const {letter} = measureRecord

      for (const [key, value] of Object.entries(measureRecord)) {
        if (key !== 'letter') {
          formattedMeasureValues[`${letter}${formatKey(key)}`] = value
        }
      }
    })

    return {
      ...formattedMeasureValues,
      ...rest
    }
  })

  const filteredMeasures = formattedMeasures.filter(
    measure => !!measure.productId
  )

  return filteredMeasures
}

export const saveProduct = async (
  productId,
  values,
  editedSections,
  form,
  hasSavedImage,
  setHasSavedImage
) => {
  const saveOperations = {
    propertiesSection: async () => {
      await EditProductProperties(
        productId,
        formatPropertiesForSubmit(values.propertiesSection)
      )
    },
    skuSection: async () => {
      await EditSKU(productId, values.skuSection)
      const newBaseSKU = values.skuSection.productCombination.find(
        combo => combo.meanValue
      )
      if (newBaseSKU) {
        await EditBaseSKU(productId, newBaseSKU)
      }
    },
    measuresSection: async () => {
      const formattedMeasures = temporaryFormatMeasuresForSubmit(
        values.measuresSection.measurements.measures
      )
      await SaveMeasures(productId, {productMeasure: formattedMeasures})
    },
    measurementImage: async () => {
      const measurementImage = values.measuresSection.measurementImage
      const payload = new FormData()
      payload.append('File', measurementImage)
      if (measurementImage.delete && hasSavedImage) {
        await DeleteProductImage(productId, measurementImage.imageId)
        setHasSavedImage(false)
        form.change('measuresSection', {
          ...form.getState().values.measuresSection,
          measurementImage: undefined
        })
      } else {
        const response = await SaveMeasureImage(productId, payload)
        if (response.success) {
          const measurementImage =
            response.data.productPropertiesSection.productImage.find(
              image => image.layout
            )

          form.change('measuresSection', {
            ...form.getState().values.measuresSection,
            measurementImage: measurementImage
          })
          setHasSavedImage(true)
        }
      }
    }
    // Add more sections here as needed:
    // compositionSection: async () => { ... },
    // measureSection: async () => { ... },
    // priceSection: async () => { ... },
    // onlineStoreSection: async () => { ... },
    // pictureSection: async () => { ... },
  }

  const operations = editedSections
    .filter(section => saveOperations[section])
    .map(section => saveOperations[section]())

  await Promise.all(operations)
}
